<template>
  <footer class="footer">
    <div class="background">
      <img v-if="!!background" :src="background" alt="background">
    </div>
    <div class="content">
      <div class="top-side">
        <div class="logo">
          <img src="./../assets/images/logo.png" alt="logo"/>
        </div>
        <nav class="navigation">
          <router-link class="nav-item" to="/home" v-html="$translations.get('header_home')">Home</router-link>
          <router-link class="nav-item" to="/bodies" v-html="$translations.get('header_bodies')">Public / Private
            bodies
          </router-link>
          <router-link class="nav-item" to="/where-we-work" v-html="$translations.get('header_where_we_work')">Where we
            work
          </router-link>
          <router-link class="nav-item" to="/contact" v-html="$translations.get('header_contact')">Contact us
          </router-link>
          <router-link class="nav-item" to="/news" v-html="$translations.get('header_news')">News</router-link>
          <router-link class="nav-item" to="/about" v-html="$translations.get('header_about')">About us</router-link>
        </nav>
      </div>
      <div class="bottom-side">
        <div class="contact">
          <ul>
            <li class="location">
              <span class="icon">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xml:space="preserve">
                  <path d="M256,0C156.748,0,76,80.748,76,180c0,33.534,9.289,66.26,26.869,94.652l142.885,230.257
                      c2.737,4.411,7.559,7.091,12.745,7.091c0.04,0,0.079,0,0.119,0c5.231-0.041,10.063-2.804,12.75-7.292L410.611,272.22
                      C427.221,244.428,436,212.539,436,180C436,80.748,355.252,0,256,0z M384.866,256.818L258.272,468.186l-129.905-209.34
                      C113.734,235.214,105.8,207.95,105.8,180c0-82.71,67.49-150.2,150.2-150.2S406.1,97.29,406.1,180
                      C406.1,207.121,398.689,233.688,384.866,256.818z"/>
                  <path d="M256,90c-49.626,0-90,40.374-90,90c0,49.309,39.717,90,90,90c50.903,0,90-41.233,90-90C346,130.374,305.626,90,256,90z
                      M256,240.2c-33.257,0-60.2-27.033-60.2-60.2c0-33.084,27.116-60.2,60.2-60.2s60.1,27.116,60.1,60.2
                      C316.1,212.683,289.784,240.2,256,240.2z"/>
                </svg>
              </span><span v-html="$settings.get('CompanyAddress')"></span>
            </li>
            <li class="phone">
              <span class="icon">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999" xml:space="preserve">
                  <path d="M498.827,377.633l-63.649-63.649c-17.548-17.547-46.102-17.547-63.649,0l-28.931,28.931
                      c-13.294,13.294-34.926,13.29-48.215,0.005l-125.4-125.507c-13.325-13.325-13.327-34.892,0-48.219
                      c4.66-4.66,18.041-18.041,28.931-28.931c17.471-17.47,17.715-45.935-0.017-63.665l-63.632-63.432
                      C116.717-4.381,88.164-4.381,70.663,13.12C57.567,26.102,53.343,30.29,47.471,36.111c-63.28,63.279-63.28,166.242-0.003,229.519
                      l198.692,198.796c63.428,63.429,166.088,63.434,229.521,0l23.146-23.145C516.375,423.733,516.375,395.181,498.827,377.633z
                       M91.833,34.382c5.849-5.849,15.365-5.85,21.233,0.016l63.632,63.432c5.863,5.863,5.863,15.352,0,21.216l-10.609,10.608
                      l-84.81-84.81L91.833,34.382z M267.38,443.213L68.687,244.415c-48.958-48.958-51.649-125.833-8.276-178.006l84.564,84.564
                      c-22.22,25.189-21.294,63.572,2.787,87.653l125.396,125.501c0.001,0.001,0.003,0.003,0.004,0.004
                      c24.055,24.056,62.436,25.042,87.656,2.792l84.566,84.566C393.377,494.787,316.675,492.508,267.38,443.213z M477.612,420.065
                      l-10.609,10.609l-84.865-84.866l10.607-10.608c5.85-5.849,15.367-5.85,21.217,0l63.649,63.649
                      C483.461,404.699,483.461,414.217,477.612,420.065z"/>
                </svg>
              </span><span v-html="$settings.get('Phone')"></span>
            </li>
            <li class="mail">
              <span class="icon">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xml:space="preserve">
                  <path d="M467,61H45C20.218,61,0,81.196,0,106v300c0,24.72,20.128,45,45,45h422c24.72,0,45-20.128,45-45V106
                      C512,81.28,491.872,61,467,61z M460.786,91L256.954,294.833L51.359,91H460.786z M30,399.788V112.069l144.479,143.24L30,399.788z
                       M51.213,421l144.57-144.57l50.657,50.222c5.864,5.814,15.327,5.795,21.167-0.046L317,277.213L460.787,421H51.213z M482,399.787
                      L338.213,256L482,112.212V399.787z"/>
                </svg>
              </span><span v-html="$settings.get('Email')"></span>
            </li>
            <li class="website">
              <span class="icon">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xml:space="preserve">
                  <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.73 20.183c-.106-.526-.236-1.046-.398-1.555.897-.811.86-2.197-.072-2.883.582-2.318.61-4.849-.002-7.288.186-.111.348-.254.475-.425 1.466.412 2.831 1.066 4.052 1.911.14.665.215 1.352.215 2.057 0 3.382-1.692 6.372-4.27 8.183zm-15.73-8.183c0-.855.12-1.682.323-2.475.699-.044 1.393-.04 2.147.032l.04.226c-.921.775-1.75 1.661-2.487 2.674l-.023-.457zm3.183-1.19c.848.643 2.083.436 2.662-.49 2.898 1.06 5.339 3.077 6.94 5.666-.766.775-.756 1.998.019 2.695-.681 1.231-1.548 2.345-2.56 3.307-4.902.117-8.924-3.262-9.969-7.697.772-1.316 1.755-2.494 2.908-3.481zm2.886-1.901c1.991-.974 4.155-1.432 6.324-1.377.305.611.93 1.076 1.666 1.166h.006c.557 2.157.583 4.472.029 6.7l-.223.023c-1.724-2.825-4.433-5.131-7.763-6.301l-.039-.211zm6.062 12.857c.702-.817 1.311-1.695 1.813-2.627l.27-.008c.172.562.308 1.139.408 1.729-.777.406-1.612.714-2.491.906zm7.103-13.598c-1.009-.56-2.076-1.002-3.189-1.311-.108-.995-1.041-1.824-2.119-1.816-.552-1.019-1.232-1.975-2.024-2.854 3.321.642 6.061 2.93 7.332 5.981zm-6.472-2.708c-.257.22-.443.515-.524.858-2.456-.03-4.778.526-6.848 1.565-.85-.638-2.07-.421-2.646.483-.728-.076-1.379-.092-2.024-.072 1.476-3.683 5.076-6.294 9.28-6.294h.001c1.097.994 2.034 2.16 2.761 3.46z"/>
                </svg>
              </span><span>www.wagner-hatfield.com</span>
            </li>
          </ul>
        </div>
        <div class="copyright" v-html="$translations.get('copyright')">
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "FooterSection",
    props: {
      background: {
        type: String
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../static/css/style';

  .footer {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: stretch;
    padding-top: 3vw;

    .background {
      z-index: 1;
      @include absolute-stretch();

      &::after {
        content: '';
        display: block;
        background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5));
        @include absolute-stretch();
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: bottom;
      }
    }

    .content {
      z-index: 2;
      position: relative;

      .top-side {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        .logo {
          margin-left: 3vw;
          width: 200px;

          img {
            max-height: 100%;
            max-width: 100%;
          }
        }

        .navigation {
          display: flex;
          flex-direction: row;
          font-family: 'NeueHaasUnicaPro-Medium', sans-serif;

          .nav-item {
            position: relative;
            text-transform: uppercase;
            font-size: 0.7rem;
            font-weight: bolder;
            margin: 0 1rem;
            padding: 0.3em;
            color: #fff;
            cursor: pointer;
            text-decoration: none;
            @include transition(color ease-in-out 200ms);


            &:hover {
              color: $accent-color;
            }
          }
        }
      }

      .bottom-side {
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        align-items: stretch;

        .contact {

          ul {
            list-style: none;
            color: rgba(255, 255, 255, 0.8);
            margin-left: 3vw;
            padding: 0;

            li {
              margin: 0.5em 0;
              font-size: 0.8rem;
              display: flex;
              flex-direction: row;

              .icon {
                display: inline-block;
                height: 1em;
                width: 1em;
                margin-right: 1em;

                svg {
                  max-width: 100%;
                  max-height: 100%;
                  fill: #fff;
                }
              }

              &.location {
              }

              &.phone {
              }

              &.mail {
              }

              &.website {
              }
            }
          }
        }

        .copyright {
          color: #fff;
          text-align: right;
          margin: 0.5vw;
          font-size: 0.7rem;
        }
      }
    }

    @include media-query(medium) {

      .content {
        display: flex;
        flex-direction: row;
        align-items: flex-start;

        .top-side {

          .logo {
            margin-left: 3vw;
            width: 120px;
          }

          .navigation {
            display: none;
          }
        }

        .bottom-side {

          .copyright {
            display: none;
          }
        }
      }
    }
  }
</style>
